// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderTitle":"c-k_gU"};